import { FC } from 'react';
import classnames from 'classnames';
import { translate } from 'translations';
import { Divider } from 'learning-panel-components';
import styles from './primaryCourse.module.scss';

const PrimaryCourse: FC<PrimaryCourseProps> = (props: PrimaryCourseProps) => {
    const { primaryCourse } = props;
    const primaryCourseLength = primaryCourse?.length || 0;
    const isLongName = primaryCourseLength > 40;

    return (
        <div className={classnames(styles.wrapper, { [styles['long-primary-course-wrapper']]: isLongName })}>
            <div className={styles.title}>{translate('PrimaryCourse')}</div>
            {isLongName && (
                <div className={styles.divider}>
                    <Divider color="rgba(255, 255, 255, 0.3)" />
                </div>
            )}
            <div className={styles['primary-course']}>{primaryCourse}</div>
        </div>
    );
};
export interface PrimaryCourseProps {
    primaryCourse?: string;
}

export default PrimaryCourse;
